import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import useTypedContext from "hooks/useTypedContext";
import { REFETCH_STACK_SETTINGS_QUERIES } from "views/Stack/Settings/constants";
import { StackSettingsContextData } from "views/Stack/Settings/Context";

import { showStackSettingsIntegrationsWebhooksCreateFormDrawer } from "../../CreateFormDrawer";
import { showStackSettingsIntegrationsWebhooksDetails } from "../../Details";
import StackSettingsIntegrationsWebhooksDropdown from "../../Dropdown";
import { WebhookIntegrationWithTimestamp } from "../types";

const StackWebhooksTableDropdownCell = ({
  item: webhook,
  ...cellProps
}: TableSimpleCellProps<WebhookIntegrationWithTimestamp>) => {
  const { stackSettings, canManageStack } = useTypedContext(StackSettingsContextData);

  const handleEditClick = () => {
    showStackSettingsIntegrationsWebhooksCreateFormDrawer({
      id: webhook.id,
      webhook,
      stackId: stackSettings.id,
    });
  };

  const handleDetailsClick = () => {
    showStackSettingsIntegrationsWebhooksDetails({ id: webhook.id, webhook });
  };

  return (
    <TableSimpleCell {...cellProps}>
      <StackSettingsIntegrationsWebhooksDropdown
        id={webhook.id}
        endpoint={webhook.endpoint}
        refetchQueriesOnDelete={REFETCH_STACK_SETTINGS_QUERIES}
        onEditClick={handleEditClick}
        onDetailsClick={handleDetailsClick}
        stackId={stackSettings.id}
        canManageStack={canManageStack}
      />
    </TableSimpleCell>
  );
};

export default StackWebhooksTableDropdownCell;
